<template>
    <div>
        <v-item-group class="betTypes" mandatory>
            <v-item v-for="(item,index) in betTypes" :key="index">
                <v-chip slot-scope="{ active, toggle }"
                        :selected="active"
                        @click="toggle" v-on:click="toggleBetType(item)">
                    {{item}}
                </v-chip>
            </v-item>
        </v-item-group>
        <div v-if="betTypesMarkets.length === 0" class="markets-unavailable">
            No Markets Currently Available.
        </div>
        <div v-for="(item,index) in betTypesMarkets" :key="item.betType">
            <v-expansion-panel v-if="item.markets.marketName !== ''" v-model="betTypesMarketsPanel[index]" class="v-btn-toggle markets" expand>
                <v-expansion-panel-content v-for="market in item.markets" :key="market.marketId" class="mb-0 market-inner">
                    <div slot="header" v-if="market.marketStatusId === 1 && market.marketName !== 'Match Winner' && market.marketName !== ''" class="marketHeader">
                        {{market.marketName}}
                    </div>
                    <div slot="header" v-else-if="market.marketName !== 'Match Winner' && market.marketName !==''" class="marketHeader">
                        {{market.marketName}} - SUSPENDED
                    </div>
                    <div v-if="market.marketName !== 'Match Winner'">
                        <v-btn v-if="market.marketName !== ''" v-scroll-to="'#betslipAnchor'" flat color="info" v-for="marketDetail in market.marketDetails" :class="{'v-btn--active': marketDetailIsInBetSlip(marketDetail.marketDetailId),  'twoMarkets':(market.marketDetails.length === 2), 'threeMarkets':(market.marketDetails.length === 3), 'disabledMarket':(marketDetail.marketDetailStatus !== 1 || market.marketStatusId !== 1 || marketDetail.marketDetailOdd === 0)}" :key="marketDetail.marketDetailId" @click="addBet(marketDetail, market.marketName, market.marketId, market.marketStatusId)">
                            <market :marketName="market.marketName" :marketDetail="marketDetail" :marketStatusId="market.marketStatusId"></market>
                            <transition name="oddIncrease">
                                <div @animationend="destroy(marketDetail)" v-if="marketDetail.css === 'oddIncrease'"></div>
                            </transition>
                            <transition name="oddDecrease">
                                <div @animationend="destroy(marketDetail)" v-if="marketDetail.css === 'oddDecrease'"></div>
                            </transition>
                        </v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import Market from './Market.vue';
    import EventBetTypesMarketsApi from '../api/eventBetTypesMarkets';
    import { HubConnection } from "@aspnet/signalr";
    import Scoreboard from './Scoreboard.vue';
    import { isNullOrUndefined } from 'util';

    export default {
        name: 'EventBetTypes',
        components: {
            Market,
            Scoreboard
        },
        data() {
            return {
                betTypesMarkets: [],
                betTypes: [],
                betTypesMarketsPanel: [],
                selectedBetType: null
            }
        },
        props: {
            connection: HubConnection,
            sport: String,
            tournament: String,
            eventId: String,
            statscoreId: Number,
            eventName: String,
            eventTime: String,
            state: Array,
            betTypeGroups: Array,
            expanded: Boolean,
        },
        watch: {
            expanded: function(newVal) {
                if (newVal) {
                    this.getMarkets()
                }
            }
        },
        methods: {
            getMarkets() {
                if (this.sport === "FormulaOne") {
                    this.getEventBetTypesMarkets(this.eventId, "Driver");
                } else {
                    this.getEventBetTypesMarkets(this.eventId, this.selectedBetType);
                }
            },
            destroy(marketDetail) {
                Vue.set(marketDetail, 'css', '')
            },
            marketDetailIsInBetSlip(marketDetailId) {
                return this.$store.getters.marketDetailIsInBetSlip(marketDetailId);
            },
            toggleBetType(betType) {
                if (!isNullOrUndefined(betType)) {
                    this.selectedBetType = betType;
                }

                if (isNullOrUndefined(this.selectedBetType)) {
                    this.getEventBetTypesMarkets(this.eventId, betType);
                }
                else {
                    this.getEventBetTypesMarkets(this.eventId, this.selectedBetType);
                }
            },
            addBet(marketDetail, betTypeName, betTypeId, marketStatusId) {
                if (marketDetail.marketDetailStatus === 1) {
                    //this.$store.dispatch('setShowBetSlipOddsAlert', false);
                    const bet = {
                        sport: this.sport,
                        tournament: this.tournament,
                        event: this.eventName,
                        time: this.eventTime,
                        betType: betTypeName,
                        css: '',
                        success: false,
                        error: false,
                        accepted: false,
                        errorMessage: '',
                        market: marketDetail.marketDetailName,
                        marketStatusId: marketStatusId,
                        marketDetailId: marketDetail.marketDetailId,
                        marketDetailStatus: marketDetail.marketDetailStatus,
                        betleg: {
                            eventId: this.eventId,
                            marketId: betTypeId,
                            marketDetailId: marketDetail.marketDetailId,
                            odds: parseFloat(marketDetail.marketDetailOdd),
                            stake: null,
                            betLegNumber: this.$store.getters.betSelectionCount + 1,
                            payout: null,
                            submitting: false
                        }
                    }
                    if (this.$store.getters.betSelectionCount + 1 <= 30) {
                        this.$store.dispatch('addBet', bet);

                    }
                }
            },
            getEventBetTypesMarkets(eventId, betType) {
                if (isNullOrUndefined(betType)) {
                    betType = "Main"
                }
                EventBetTypesMarketsApi.getEventBetTypesMarkets(eventId, betType)
                    .then(data => {
                        this.betTypesMarkets = data.responseObject;
                        let betTypesMarketsLength = this.betTypesMarkets.length;
                        if (betTypesMarketsLength > 0) {
                            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                                for (let x = 0; x < betTypesMarketsLength; x++) {
                                    this.betTypesMarketsPanel.push([]);
                                    if (this.betTypesMarkets[x].markets.length > 0) {
                                        for (let y = 0; y < this.betTypesMarkets[x].markets.length; y++) {
                                            this.betTypesMarketsPanel[x].push(true)
                                        }
                                    }
                                    else {
                                        this.betTypesMarketsPanel.push(false);
                                    }
                                }
                            }
                            else {
                                for (let x = 0; x < betTypesMarketsLength; x++) {
                                    this.betTypesMarketsPanel.push([]);
                                    if (this.betTypesMarkets[x].markets.length > 0) {
                                        for (let y = 0; y < this.betTypesMarkets[x].markets.length; y++) {
                                            this.betTypesMarketsPanel[x].push(true)
                                        }
                                    }
                                    else {
                                        this.betTypesMarketsPanel.push(true);
                                    }
                                }
                            }
                        }
                    })
            },
            updateMarketDetail(updatedMarketDetail) {
                for (let betTypeMarket of this.betTypesMarkets) {
                    for (let market of betTypeMarket.markets) {
                        if (market.marketStatusId !== updatedMarketDetail.MarketStatus && market.marketId === updatedMarketDetail.MarketID) {
                            market.marketStatusId = updatedMarketDetail.MarketStatus;
                        }
                        for (let marketDetail of market.marketDetails) {
                            if (marketDetail.marketDetailId === updatedMarketDetail.MarketDetailID) {
                                if (marketDetail.marketDetailStatus !== updatedMarketDetail.Status) {
                                    if (marketDetail.marketDetailStatus !== updatedMarketDetail.Status) {
                                        marketDetail.marketDetailStatus = updatedMarketDetail.Status
                                    }
                                }
                                if (updatedMarketDetail.Price > marketDetail.marketDetailOdd) {
                                    Vue.set(marketDetail, 'css', 'oddIncrease');
                                    marketDetail.marketDetailOdd = updatedMarketDetail.Price;
                                } else if (updatedMarketDetail.Price < marketDetail.marketDetailOdd) {
                                    Vue.set(marketDetail, 'css', 'oddDecrease');
                                    marketDetail.marketDetailOdd = updatedMarketDetail.Price;
                                }
                                else {
                                    Vue.set(marketDetail, 'css', '');
                                }
                            }
                        }
                    }
                }
            },
        },
        mounted() {
            this.betTypes = this.betTypeGroups
            

            if (this.connection) {
                let lastCallTime = 0;

                this.connection.on(this.eventId + "ebt-rcv", (value) => {
                    if (value !== null) {
                        this.updateMarketDetail(JSON.parse(value));

                        const marketStatus = JSON.parse(value).MarketStatus;
                        if (marketStatus === 3) {
                            const currentTime = Date.now();
                            if (currentTime - lastCallTime >= 2000) {
                                this.getEventBetTypesMarkets(this.eventId, this.selectedBetType);
                                lastCallTime = currentTime;
                            }
                        }
                    }
                });
            }
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .whiteBorder {
        border: 1px solid white !important
    }

    .theme--dark.v-expansion-panel .v-expansion-panel__container {
        border-top: 0px solid white !important
    }

    .betTypes {
        margin-bottom: 0px;
    }

    .flex.grey.darken-2.marketHeader {
        color: #FFFFFF;
    }

    .info--text {
        background-color: #2b2b2b !important;
        color: #fff !important;
        opacity: 1 !important;
        border: 0px solid #787777 !important;
        position: relative;
    }

        .info--text:hover {
            background-color: #020381 !important;
            border-color: #020381;
        }

    .markets {
        display: inline-block;
        width: 100%;
    }

    .marketHeader {
        padding-left: 10px;
        padding-top: 9px;
        padding-bottom: 8px;
        background-color: #696969;
        font-size: 15px;
    }

    .markets-unavailable {
        padding-left: 10px !important;
        padding-bottom: 10px;
        padding-top: 10px;
    }

    .theme--dark.v-expansion-panel .v-expansion-panel__container[data-v-03885e22]:nth-child(1) {
        border-top: 0px solid white !important;
    }

    .marketTextholder {
        border-bottom: 1px solid #000 !important;
    }

    .oddIncrease-enter-active {
        animation: increase 6s;
        position: absolute;
        bottom: 23px;
        right: -4px;
    }

    @keyframes increase {
        100% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        80% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        60% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        40% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        20% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        0% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }
    }

    .oddDecrease-enter-active {
        animation: decrease 6s;
        position: absolute;
        top: 23px;
        right: -5px;
        transform: rotate(90deg);
    }

    @keyframes decrease {
        100% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        80% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        60% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        40% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        20% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        0% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .oddIncrease-enter-active {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
            bottom: 22px;
        }

        .oddDecrease-enter-active {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
            top: 22px;
        }
    }

    @supports (-ms-ime-align:auto) {
        .oddIncrease-enter-active {
            transform: translateY(-9px);
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
        }

        .oddDecrease-enter-active {
            transform: translateY(9px) rotate(90deg);
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
        }
    }

    .purple {
        border: 1px solid #343434 !important;
        font-weight: 600;
    }



    .v-item-group.betTypes.theme--dark {
        background-color: #020381;
    }

    .theme--dark.v-btn.v-btn--disabled, .theme--dark.v-btn.v-btn--disabled .v-btn__loading, .theme--dark.v-btn.v-btn--disabled .v-icon {
        color: #fff !important;
        pointer-events: auto !important;
        cursor: not-allowed;
        opacity: 0.3 !important;
        background: transparent !important;
    }

    .theme--dark.v-chip {
        color: #FFFFFF;
        border-radius: 0px;
        background: transparent !important;
        font-size: 14px;
        margin: 0px !important;
    }

        .theme--dark.v-chip.v-item--active {
            background: transparent !important;
        }

        .theme--dark.v-chip:focus {
            color: #fff;
        }

        .theme--dark.v-chip:hover {
            background: #020381;
            color: #fff;
        }

    .v-chip--active:after, .v-chip--selected, .v-chip--selected:after, .v-chip:focus:not(.v-chip--disabled):after {
        background: transparent !important;
        color: #fff !important;
        opacity: 1;
        box-shadow: none !important;
        border-bottom: 2px solid #f4ea22;
    }

    .v-chip--active, .v-chip--selected, .v-chip:focus:not(.v-chip--disabled) {
        border-bottom: 2px solid #f4ea22 !important;
    }

    .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
        background-color: #585858;
    }

    .v-btn--active,
    .v-btn-toggle .v-btn.v-btn--active {
        background-color: #020381 !important;
        border-right-color: #020381 !important;
    }

    .v-btn-toggle .v-btn {
        width: 33.3%;
    }

    @media (min-width:960px) {
        .threeMarkets {
            width: 33.3% !important;
        }

        .twoMarkets {
            width: 50% !important;
        }
    }

    @media (max-width:960px) {
        .v-btn-toggle .v-btn {
            width: 100% !important;
        }

        .info--text {
            border-bottom-color: transparent !important;
        }

            .info--text:last-child {
                border-bottom-color: #787777 !important;
            }
    }

    .theme--dark.v-btn-toggle, .v-btn-toggle--selected {
        background: none !important;
        box-shadow: none;
    }

    .disabledMarket {
        opacity: 1 !important;
        color: red;
        border-right: solid 1px #787777 !important;
        cursor: default;
        pointer-events: none;
    }

    .info--text:hover.disabledMarket {
        background-color: #2b2b2b !important;
        border: 1px solid #787777;
    }
</style>
